import React from 'react';
import style from './projects.module.css';

import styled from 'styled-components';

import { Link } from './Components.js';

import { Circle, HalfCircle, FilledCircle, FilledHalfCircle } from './Shapes';

import CoffeeMachine from './CoffeeMachine';

import animatedStyle from './animatedeffects.module.css';

const HaadingText = styled('h1')`
  color: var(--secondary-text-color);
  font-size: 2.5rem;
  &:hover {
    color: var(--tertiary-color-a);
  }
`

const ProjectText = styled('p')`
  color: var(--tertiary-color-b);
  margin-left:10vw;
  margin-right:2vw;
  padding-top:1vh;
  padding-bottom:1vh;
  text-align:left;
  font-size: 1.1rem;
  border-top: 1px solid var(--tertiary-color-b);
  border-top-width: 4px;
  z-index:1;
  /* &:hover {
    color: var(--tertiary-color-a);
  } */
`


export default function Projects() {
  return <div id="projects" className={style.main}>
        <h2 style={{
            fontSize:80,
            color:'var(--tertiary-color-b'}}> Projects </h2>
        <div className={style.container}>
            <HaadingText>
                2022
            </HaadingText>

            <ProjectText>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://tudorelu.github.io/billiondollarpage/"
                    >
                🌐 <b>BillionDollarWebPage</b>
                </Link>&nbsp;
                
                <br/><br/>
                I developed the <u>website and smart contract</u> for this 
                NFT project which (together with a friend) we built 
                as a way to exercise our smart contract programming
                skills and see how fast we could deploy a working
                prototytpe (took us less than a month). It's currently living on the 
                Ethereum testnet.
            </ProjectText>

            <ProjectText>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://tudorelu.github.io/adaku-website/"
                    >
                🌐 <b>Adaku NFT</b> project
                </Link>&nbsp;
                
                <br/><br/>
                This is another NFT project which I started around the same
                time as the BillionDollarWebPage, in my mission to learn
                about NFTs. I developed the <u>website</u>.
            </ProjectText>

            <HaadingText>
                2021
            </HaadingText>
            <ProjectText>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://ieeexplore.ieee.org/document/9650873/"
                    >
                📝
                </Link>&nbsp;
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://tudorelu.github.io/eth-oci-paper/"
                    >
                🌐
                </Link>&nbsp;
                <b>Ethereum On-Chain Deep Learning Paper (& Webapp) </b>
                <br/><br/>
                Academic paper published in IEEE Access on using data generated 
                by the activity on the Ethereum network as inputs to a deep learning 
                model aimed at predicting Ethereum prices.
            </ProjectText>

            <ProjectText>
                (Offline) <b>Jujuque</b> algo trading web-app which integrates with Pyjuque.
                <br/><br/>
                While developing python algo tools I decided to improve my 
                backend programming skills by building this <b>flask</b>-based website, 
                which uses postgres via the <b>SQLAlchemy</b> ORM & a Redis queue to 
                schedule & orchestrate background jobs. 
                <b> Currently offline due to high AWS costs but happy to show it on request.</b>
            </ProjectText>
            <HaadingText>
                2020
            </HaadingText>

            <ProjectText>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://github.com/tudorelu/pyjuque"
                    >
                🌐
                </Link>&nbsp;
                <b>Pyjuque</b> open source algo trading library 
            </ProjectText>

            <ProjectText>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://ieeexplore.ieee.org/abstract/document/9359745"
                    >
                📝
                </Link>&nbsp;
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://on-chain-indis-paper.herokuapp.com/"
                    >
                🌐
                </Link>&nbsp;
                <b>Bitcoin On-Chain Analysis Paper (& Webapp) </b>
                <br/><br/>
                Academic paper published in IEEE Access on the potential usage of 
                Bitcoin on-chain analytics in developing trading strategies.

            </ProjectText>

            <HaadingText>
                2019
            </HaadingText>
            <ProjectText>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://apps.apple.com/us/app/eazitrip/id1484011233"
                    >
                📱
                </Link>&nbsp;
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://eazitrip.com/"
                    >
                🌐 <b>Eazitrip.com </b>
                </Link>&nbsp;
                <br/><br/>
                EaziTrip is a travel app helping travellers find 
                authentic and unique experiences when aborad, using AR. 
                As the hacker in this 2 person start-up my work was in 
                building the <b> mobile app</b>.
            </ProjectText>

            <ProjectText style={{
                borderTop:0, 
                marginTop:'100px', 
                marginBottom:'100px', 
                fontSize:'1.6rem',
                textAlign:'justify',
                marginLeft:'2vw'}}>
                <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://docs.google.com/document/d/1LaCuLOXaweZMEhnuZL5WHwSsi0kBEwwjso1l5ZN-Mf0/edit?usp=sharing"
                    >
                🌐
                </Link>&nbsp;
                <b> &lt;-- Click this link for more projects with images.</b>
            </ProjectText>

            <CoffeeMachine />


            <ul className={animatedStyle.circles}>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>

        </div>

        <FilledHalfCircle 
            size={250}
            color={'var(--tertiary-color-a)'}
            style={{
                top:0, 
                right: 'max(30px, calc(25vw - 125px))', 
                transform: 'rotateX(-180deg)',
                zIndex:0}}/>    

        {/* Bottom Middle Circle */}
        <Circle 
            size={80}
            color={'var(--primary-bg-color)'}
            style={{bottom:120, left: 'calc(50px)'}}/>
        <FilledHalfCircle 
            size={250}
            color={'var(--primary-bg-color)'}
            style={{
                bottom:0, 
                left: 'calc(-100px)', 
                zIndex:0}}/>    
        {/* Bottom Middle (Below) Circle */}
        <FilledCircle 
            size={70}
            color={'var(--secondary-text-color)'}
            style={{
                bottom:-35, left: '300px',
                transform: 'rotateX(-180deg)'
            }}/>
      </div>;
}
